import dayjs from 'dayjs';

export const CLIENT_FETCH_ERROR_MESSAGE =
  'Lỗi đã xảy ra! Bạn hãy kiểm tra kết nối Internet hoặc liên hệ admin để được trợ giúp. Xin cảm ơn!';

export const STATUS_COLOR = {
  canceled: { color: '#ff113c', bgColor: '#FFEEEE' },
  checked_out: { color: '#1683FF', bgColor: '#EDF5FF' },
  confirmed: { color: '#1683FF', bgColor: '#EDF5FF' },
  dispatched: { color: '#1683FF', bgColor: '#EDF5FF' },
  delivering: { color: '#1683FF', bgColor: '#EDF5FF' },
  pending_cancellation: { color: '#ff113c', bgColor: '#FFEEEE' },
  delivery_unsuccessful: { color: '#ff113c', bgColor: '#FFEEEE' },
  completed: { color: '#00A75A', bgColor: '#EFEFEF' },
  splitted: { color: '#1683FF', bgColor: '#EDF5FF' },
  draft: { color: '#8A8A8A', bgColor: '#EFEFEF' },
};

export const TRIP_STATUS_MAP = {
  canceled: 'Hủy giao hàng',
  arrived_receipt_address: 'Đã đến điểm nhận hàng',
  delivery_unsuccessful: 'Giao không thành công',
  arrived_delivery_address: 'Đã đến điểm giao hàng',
  delivery_successful: 'Giao hàng thành công',
  started: '',
};

export const TRIP_STATUS_COLOR = {
  canceled: { color: 'rgba(255, 17, 60, 1)', bgColor: 'rgba(255, 17, 60, 0.1)' },
  arrived_receipt_address: { color: 'rgba(239, 102, 49, 1)', bgColor: 'rgba(255, 166, 130, 0.2)' },
  delivery_unsuccessful: { color: 'rgba(255, 17, 60, 1)', bgColor: 'rgba(255, 17, 60, 0.1)' },
  arrived_delivery_address: { color: 'rgba(239, 102, 49, 1)', bgColor: 'rgba(255, 166, 130, 0.2)' },
  delivery_successful: { color: 'rgba(85, 177, 138, 1)', bgColor: 'rgba(103, 202, 160, 0.2)' },
  started: { color: 'gray', bgColor: 'gray' },
};

export const PERMISSION_VIEW_PRICE = 'variant:view_price';
export const PERMISSION_VIEW_DEBT_AND_PAYMENT = 'account_page:view_debt_and_payment';
export const PERMISSION_PLACE_ORDER = 'order:place_order';
export const PERMISSION_UPDATE_ORDER = 'order:update_order';
export const PERMISSION_CHECK_INVENTORY = 'inventory:check';

export const ITEM_PER_PAGE = 10;
// TODO: BE slow at the moment, better response time in the future
export const PERFORMANCE_ITEM_PER_PAGE = 5;

export const CONDITION_ITEMS_PER_PAGE = 10;
export const ORDER_ITEMS_PER_PAGE = 25;

export const ITEMS_PER_INSTANT_SEARCH = 5;
export const ITEMS_SHOW_INSTANT_SEARCH = 4;

export const INITIAL_START_DATE = dayjs().startOf('month').format('DD/MM/YYYY');
export const INITIAL_END_DATE = dayjs().endOf('month').format('DD/MM/YYYY');

export const FILE_SIZE_LIMIT = 25e6;

export const FI_STATUS_CLEARED = 'cleared';
export const FI_STATUS_NOT_CLEARED = 'not cleared';

export const TYPE_A = 'Type A';
export const TYPE_B = 'Type B';

export const USER_TYPE_MANAGER = 'manager';
export const USER_TYPE_MIDDLE_MANAGER = 'middle_manager';
export const USER_TYPE_MEMBER = 'member';

export const URL_NANOCO_QUOTATION = 'https://bit.ly/Pricelist042023';
export const URL_NANOCO_POINT_OF_PURCHASE = 'https://www.nanoco.com.vn/pages/xem-diem-mua-hang';
export const TEST_CUSTOMER_ID = 4369;

export enum FeatureFlag {
  SelectedCart = 'SELECTED_CART_FEATURE',
}

export const CHANNEL_LEVEL_1 = 11;
export const CHANNEL_LEVEL_2 = 16;

export enum WarrantyOrderStatus {
  received = 'Đã tiếp nhận',
  not_processed = 'Chưa xử lý',
  draft = 'Bản nháp',
}
export const SAP_CUSTOMER_TEST_ID_START_WITH = '900';
